// src/config/news.ts
import type { NewsItem } from '@/app/core/mainPage/prompt/shared/types';

export const newsItems: NewsItem[] = [
  {
    id: '1',
    title: 'Обновление 2.1',
    summary: 'Добавлена поддержка GPT-4o и Claude 3.5 Sonnet, улучшена скорость генерации в 1.5 раза.',
    fullText: 'Мы рады представить обновление 2.1! В этой версии добавлена поддержка новейших моделей GPT-4o и Claude 3.5 Sonnet. Скорость генерации текста увеличена в 1.5 раза благодаря оптимизации WebSocket-соединений. Также исправлены ошибки в мобильной верстке и добавлены анимации перехода между вкладками.',
    imageUrl: 'https://media.giphy.com/media/3o7TKsQ8l7iC0eGxEI/giphy.gif', // GIF-превью
  },
  {
    id: '3',
    title: 'Обновление 2.3',
    summary: 'Расширенные настройки профиля и новая система рефералов.',
    fullText: '...',
    imageUrl: 'https://images.unsplash.com/...',
    background: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=400', // фоновое изображение
  },
  {
    id: '2',
    title: 'Обновление 2.2',
    summary: 'Новый дизайн чата, поддержка загрузки файлов и улучшенная безопасность.',
    fullText: ' ',
    background: '#6366f1', // градиентный цвет
  },
  // новые тут делаю
  // для переноса /n используйте для жирного <br></br> для курсива <cr></cr>
  /*КОПИЯ СКЛЕТА ПРОСТО КОПИРУЙ И ИЗМЕНЯЙ:
  {
    id: ' цифрра ',
    title: ' название ',
    summary: ' краткое содержание ',
    fullText: ' полный текст ',
    imageUrl: ' фото/гиф внутри',
    background: 'либо ссылка на фото/либо цвет (можно градиент) пример цвета (#6366f1)', // фоновое изображение
  },*/
];